import { render, staticRenderFns } from "./AiBulkSelectBar.vue?vue&type=template&id=20ed0b14&scoped=true"
import script from "./AiBulkSelectBar.vue?vue&type=script&lang=js"
export * from "./AiBulkSelectBar.vue?vue&type=script&lang=js"
import style0 from "./AiBulkSelectBar.vue?vue&type=style&index=0&id=20ed0b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ed0b14",
  null
  
)

export default component.exports